import { PolIcon } from "components/PolIcon/policon";
import React from 'react';
import { getPennylaneFieldLabel } from "v4/features/front/pennylane/pennylane.fieldLabels";

export default function PennylaneError422({ errorData }) {
    const fields = errorData?.data?.fields ?? [];

    return (
        <div className="pennylane-error-modal__422">
            {errorData?.details && (
                <p className="pennylane-error-modal__intro">{errorData.details}</p>
            )}
            <ul className="pennylane-error-modal__fields">
                {fields.map((field, index) => (
                    <li key={`${field.name}-${index}`} className="pennylane-error-modal__field">
                        <span className="pennylane-error-modal__field-name" title={field.name}>
                            {getPennylaneFieldLabel(field.name)}
                        </span>
                        <ul className="pennylane-error-modal__messages">
                            {(field.messages ?? []).map((message, messageIndex) => (
                                <li key={messageIndex}>
                                    <PolIcon icon="warning"/>
                                    {message}
                                </li>
                            ))}
                        </ul>
                    </li>
                ))}
            </ul>
        </div>
    );
}
